import { parsePhoneNumberFromString } from "libphonenumber-js";

// Backend stores international numbers without the "+"; normalize for display.
// Adapted from the reference: react-phone-number-input replaced with
// libphonenumber-js (the only piece we used was international formatting).
export function toE164(value?: string | null): string {
  const trimmed = value?.trim();
  if (!trimmed) return "";
  return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
}

export function fromE164(value?: string | null): string {
  const trimmed = value?.trim();
  if (!trimmed) return "";
  return trimmed.startsWith("+") ? trimmed.slice(1) : trimmed;
}

export function formatPhoneNumberForDisplay(phone?: string | null): string {
  const trimmed = phone?.trim();
  if (!trimmed) return "";

  const compact = trimmed.replace(/[\s\-()]/g, "");
  let normalized = compact;

  if (compact.startsWith("00")) normalized = `+${compact.slice(2)}`;
  else if (compact.startsWith("966")) normalized = `+${compact}`;
  else if (compact.startsWith("05")) normalized = `+966${compact.slice(1)}`;
  else if (/^5\d{8}$/.test(compact)) normalized = `+966${compact}`;

  return (
    parsePhoneNumberFromString(normalized)?.formatInternational() || trimmed
  );
}

/**
 * Saudi-aware normalization of user input to E.164 digits without the leading
 * "+" (backend convention). Returns null when the input is not a valid number.
 */
export function normalizePhoneInput(value: string): string | null {
  const compact = value.trim().replace(/[\s\-()]/g, "");
  if (!compact) return null;

  let candidate = compact;
  if (compact.startsWith("00")) candidate = `+${compact.slice(2)}`;
  else if (compact.startsWith("05")) candidate = `+966${compact.slice(1)}`;
  else if (/^5\d{8}$/.test(compact)) candidate = `+966${compact}`;
  else if (!compact.startsWith("+")) candidate = `+${compact}`;

  const parsed = parsePhoneNumberFromString(candidate, "SA");
  if (!parsed?.isValid()) return null;
  return fromE164(parsed.number);
}

/**
 * True when `phoneE164` (digits, no +) is the signed-in driver's own number —
 * the login phone or the calling phone. A driver cannot message themselves.
 */
export function isDriverOwnNumber(
  driver: { phone: string | null; callingPhone: string | null } | undefined,
  phoneE164: string,
): boolean {
  if (!driver) return false;
  return phoneE164 === driver.phone || phoneE164 === driver.callingPhone;
}
